import { Text } from '../..'

import styles from './FeatureSection.module.scss'

export interface FeatureSectionProps {
  title: string
  img: JSX.Element
  className?: string
  description: string
}

export const FeatureSection = ({
  img,
  title,
  className,
  description,
}: FeatureSectionProps) => (
  <div className={className}>
    {img}
    <Text
      size='xl'
      align='left'
      element='h2'
      variantCount='600'
      variant='neutralCool'
      className={styles.title}
    >
      {title}
    </Text>
    <Text variant='neutralCool' variantCount='800'>
      {description}
    </Text>
  </div>
)
